// extracted by mini-css-extract-plugin
module.exports = {"main":"Poster_main__3sY_z","search":"Poster_search__10tPN","posters":"Poster_posters__2xzDx"};